export function getCurrencySymbol(currencyCode: string) {
  try {
    return new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency: currencyCode,
    })
      .formatToParts(1)
      .find((part) => part.type === "currency")!.value;
  } catch (error) {
    console.error("Failed to get currency symbol:", error);
    return "";
  }
}

export function getValueWithCurrency(
  value: number | string,
  currencyCode: string,
  options: Intl.NumberFormatOptions | undefined = {}
) {
  const valueAsNumber = Number(value);
  if (!isFinite(valueAsNumber)) return value;

  try {
    return new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency: currencyCode,
      ...options,
    }).format(valueAsNumber);
  } catch (error) {
    console.error("Failed to get currency value:", error);
    return value;
  }
}
